<template>
  <main class="main">
    <div class="container">
      <div class="trade-up">
        <!-- <PagesTradeUpComponentsLiveFeed v-if="livefeedShow" /> -->
        <div class="trade-up__header">
          <h1 class="trade-up__title nowrap">
            {{ t("trade_up.title") }}
          </h1>
          <PagesTradeUpComponentsHistory />
        </div>

        <div class="trade-up__body">
          <div
            v-show="!showContract"
            class="lside card card-dark"
          >
            <PagesTradeUpComponentsItemsToChoose
              @show-contract="() => (showContract = true)"
            />
          </div>
          <div
            v-show="showContract"
            class="rside card card-dark"
          >
            <PagesTradeUpComponentsContractSide
              @back="() => (showContract = false)"
            />
          </div>
        </div>

        <PagesMarketComponentsQuestionsHub
          v-if="faq?.length"
          :items="faq"
          class="mt30"
        />
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
const localePath = useLocalePath();
const { locale, t } = useI18n();
const showContract = ref(false);

// const livefeedShow = computed(
//   () => !process.server && !localStorage.getItem('trade-up-live-feed'),
// )
const faq = computed(() => {
  const items: { name: string, value: string }[] = [];
  Array.from({ length: 6 }, (_, i) => i + 1).forEach((i) => {
    items.push({
      name: t(`trade_up.faq.faq_${i}_title`),
      value: t(`trade_up.faq.faq_${i}_desc`),
    });
  });
  return items;
});

const title = computed(() => {
  return t('trade_up.seo_title');
});
const description = computed(() => {
  return t('trade_up.seo_desc');
});
// const weaponIcon = 'https://csmarketcap.com/img/logo-bg-black.png';
const { alternateLinks, canonical } = useAlternateLinks(`/trade-up`);

useHead({
  title: () => title.value,
  meta: [
    {
      name: 'keywords',
      content:
          'steam, counter strike global offensive, csgo, cs2, skins, items',
    },
  ],
  link: () => alternateLinks.value,
});

useSeoMeta({
  title: () => title.value,
  ogTitle: () => title.value,
  description: () => description.value,
  ogDescription: () => description.value,
  // ogImage: () => weaponIcon,
  twitterCard: 'summary_large_image',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  // twitterImage: () => weaponIcon,
  ogSiteName: 'CSMarketCap',
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogLocale: () => locale.value,
});

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: t('main'), item: '/' },
      {
        name: title,
        item: localePath('/trade-up'),
      },
    ],
  }),
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faq.value.map(item => ({
      '@type': 'Question',
      'name': item.name,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': item.value,
      },
    })),
  },
]);
</script>

<style lang="scss" scoped>
.main {
  .container {
    max-width: 1744px;
  }

  .trade-up {
    padding: 36px 0;

    .rside {
      @media screen and (min-width: 989px) {
        display: block !important;
      }
    }

    &__header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 36px;
    }

    &__title {
      @media screen and (max-width: 989px) {
        display: none;
      }
    }

    &__history {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &__body {
      display: grid;
      gap: 32px;
      grid-template-columns: repeat(2, 1fr);
      min-height: 700px;

      .card {
        padding: 20px;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
    }
  }
}

@media screen and (max-width: 989px) {
  .main {
    margin-top: 0;

    .trade-up {
      padding: 12px 0;

      &__header {
        margin-bottom: 16px;
      }

      &__body {
        gap: 0;
        display: block;

        .card {
          padding: 0;
          background: none;
        }
      }
    }
  }
}
</style>
